<div style="padding: 24px">
  <mat-icon style="float: right; cursor: pointer" mat-dialog-close
    >close</mat-icon
  >
  <h5 class="heading">{{ "Privicy Policy" | translate }}</h5>
  <div *ngIf="policy" class="subheading" [innerHTML]="policy.content"></div>

  <!-- <p class="subheading" >{{ policy.content }}</p> -->
</div>
